module.exports = __webpack_public_path__ + "img/no-seat.abdfba78.png";